'use strict'

const extend = require('extend')
const Util = require('./util')

class Policy {

    constructor(document, defaultVersion) {
        this.defaultVersion = defaultVersion
        this.document = extend(
            true,
            {},
            document || Util.getDefaultPolicyJson(this.defaultVersion)
        )
        this._generateServicesByResource = true
        this._servicesByResource = null
    }

    /**
     * Should be overridden
     */
    innerFactory(document) {
        throw new Error('Base class create should be overridden')
    }

    get servicesByResource() {
        if (this._generateServicesByResource) {
            this._servicesByResource = Util.getActionsByResource(this.document)
            this._generateServicesByResource = false
        }
        return this._servicesByResource
    }

    mergeWith(policy) {
        this._generateServicesByResource = true
        const resourceToActions = {}
        Util.populateActionMap(resourceToActions, this)
        Util.populateActionMap(resourceToActions, policy)

        const document = extend(
            true,
            Util.getDefaultPolicyJson(this.defaultVersion)
        )
        document.Statement = []
        Object.keys(resourceToActions).forEach(r => {
            const s = {
                Effect: Util.PolicyStatementEffect.Allow,
                Action: [],
                Resource: r
            }
            document.Statement.push(s)
            const actions = resourceToActions[r]
            Object.keys(actions).forEach(service => {
                Object.keys(actions[service]).forEach(activity => {
                    s.Action.push(Util.makeActionString(service, activity))
                })
            })
        })
        return this.innerFactory(document)
    }

    addAction(service, activity, resource, effect) {
        this._generateServicesByResource = true
        const e = effect || Util.PolicyStatementEffect.Allow
        this.document.Statement.push({
            Effect: e,
            Action: [ Util.makeActionString(service, activity) ],
            Resource: resource
        })
        return this
    }

    toString() {
        return JSON.stringify(this.document)
    }

}

module.exports = Policy



//////////////////
// WEBPACK FOOTER
// ./~/@gsm/authorizer/lib/common/policy.js
// module id = 161
// module chunks = 51